import styled from "styled-components";

const ContentWrapper = styled.div`
	display: flex;
	padding: 10px;
	flex-direction: column;
	align-items: center;
	gap: 10px;
	flex: 1 0 0;
	border-radius: 20px;
	background: linear-gradient(180deg, #262338 0%, rgba(5, 5, 18, 0) 100%);

	@media (min-width: 1024px) {
		padding: 10px 20px;
	}
`;

export { ContentWrapper };
